<template>
    <kgr-form-scaffold
        :pending="pending"
        :with-save-button="false"
        @backBtnClicked="back"
    >
        <div>
            <div class="kgr-row">
                <div class="kgr-grid kgr-grid--columnGutters kgr-grid--inlineBlock">
                    <div
                        class="kgr-grid__cell"
                    >
                        <kgr-dropdown
                            :options="sortByOptions"
                            :value="sortBy"
                            :label="$t('Sortieren nach')"
                            no-null-option
                            display="label"
                            @post-input="sortBy = $event"
                        />
                    </div>
                    <div
                        class="kgr-grid__cell"
                    >
                        <kgr-dropdown
                            :options="sortOrderOptions"
                            :value="sortOrder"
                            :label="$t('sort')"
                            no-null-option
                            display="label"
                            @post-input="sortOrder = $event"
                        />
                    </div>
                </div>
            </div>
            <div v-if="bookedList.length">
                <div class="kgr-row">
                    <div class="kgr-postfix kgr-postfix--center kgr-postfix--tinyGutters">
                        <div class="kgr-postfix__fixed">
                            <h2 class="kgr-headline kgr-headline--h2">
                                {{ $t('Teilnehmer') }}
                            </h2>
                        </div>
                        <div
                            class="kgr-postfix__fixed kgr-postfix__fluid"
                            style="text-align: right"
                        >
                            <div
                                v-if="!pendingOffering && offering && offering.canCreateOfferingBookings"
                                style="display: inline-block;"
                            >
                                <kgr-offering-live-search-result-preview
                                    :club-id="clubId"
                                    :offering="offering"
                                    :is-dog-search="isDogExam"
                                    :custom-placeholder-string="placeholderString"
                                    :loading-add-participant="loadingAddParticipant"
                                    with-custom-placeholder
                                    @memberSelected="(data) => saveParticipant(data)"
                                    @dogAndMemberSelected="(data) => saveDogAndParticipant(data)"
                                    @update:selectedSalesListOfferingItems="selectedSalesListOfferingItems = $event"
                                    @openModal="showSelectedParticipantModal = true"
                                    @closeModal="showSelectedParticipantModal = false"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="xScrollable">
                    <table
                        class="kgr-table kgr-table--block kgr-table--striped data-table table-groups printable"
                        style="margin-bottom: 20px"
                    >
                        <thead>
                            <tr class="kgr-table__row">
                                <th
                                    class="kgr-table__cell kgr-table__cell--headline"
                                    style="min-width: 100px"
                                >
                                    {{ $t('Name') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Status') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Aktion') }}
                                </th>
                                <th
                                    v-show="showColumn(TableColumn.CONTRACT_STATUS)"
                                    class="kgr-table__cell kgr-table__cell--headline"
                                >
                                    {{ $t('booking.contractStatus') }}
                                </th>
                                <th
                                    v-show="showColumn(TableColumn.EMAIL)"
                                    class="kgr-table__cell kgr-table__cell--headline"
                                >
                                    {{ $t('booking.email') }}
                                </th>
                                <th
                                    v-show="showColumn(TableColumn.PHONE)"
                                    class="kgr-table__cell kgr-table__cell--headline"
                                >
                                    {{ $t('booking.phone') }}
                                </th>
                                <th
                                    v-show="showColumn(TableColumn.PHONE_MOBILE)"
                                    class="kgr-table__cell kgr-table__cell--headline"
                                >
                                    {{ $t('booking.phoneMobile') }}
                                </th>
                                <th
                                    v-show="showColumn(TableColumn.AGE)"
                                    class="kgr-table__cell kgr-table__cell--headline"
                                >
                                    {{ $t('booking.age') }}
                                </th>
                                <th
                                    v-show="showColumn(TableColumn.EMERGENCY_CONTACT)"
                                    class="kgr-table__cell kgr-table__cell--headline"
                                >
                                    {{ $t('booking.emergencyContact') }}
                                </th>
                                <th
                                    v-show="showColumn(TableColumn.CONTRACT_END)"
                                    class="kgr-table__cell kgr-table__cell--headline"
                                >
                                    {{ $t('booking.contractEnd') }}
                                </th>
                                <th
                                    v-show="showColumn(TableColumn.DEPARTMENTS)"
                                    class="kgr-table__cell kgr-table__cell--headline"
                                >
                                    {{ $t('Abteilungen') }}
                                </th>
                                <th
                                    v-show="showColumn(TableColumn.COMMENT)"
                                    class="kgr-table__cell kgr-table__cell--headline"
                                >
                                    {{ $t('booking.comment') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline openConfigColumn">
                                    <span class="kgr-tooltip kgr-tooltip--left kgr-tooltip--styled">
                                        <kgr-icon
                                            class="kgr-icon kgr-icon--tiny openConfig kgr-tooltip__trigger"
                                            icon-class="settings"
                                            @click="openTableConfigurationDialog()"
                                        />
                                        <span class="kgr-tooltip__content">{{ $t('offering.tableConfig') }}</span>
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="attendee in bookedList"
                                :key="attendee.id"
                                class="kgr-table__row"
                            >
                                <td
                                    class="kgr-table__cell"
                                >
                                    {{ attendee.member.fullName }}
                                </td>
                                <td class="kgr-table__cell">
                                    {{ $t('attendanceList.member.status.' + attendee.status) }}
                                </td>
                                <td class="kgr-table__cell">
                                    <kgr-button
                                        v-if="attendee.status !== 'present'"
                                        :value="$t('als Anwesend markieren')"
                                        type="blue"
                                        @click="changeStatus(attendee, 'present')"
                                    />
                                    <kgr-button
                                        v-if="attendee.status !== 'absent'"
                                        :value="$t('als Abwesend markieren')"
                                        type="red"
                                        @click="changeStatus(attendee, 'absent')"
                                    />
                                    <kgr-button
                                        v-if="attendee.status !== 'none'"
                                        :value="$t('Status wieder entfernen')"
                                        type="grey"
                                        @click="changeStatus(attendee, 'none')"
                                    />
                                </td>
                                <td
                                    v-show="showColumn(TableColumn.CONTRACT_STATUS)"
                                    class="kgr-table__cell kgr-table__cell--noGrow"
                                >
                                    <kgr-member-contract-state-icon :state="attendee.member.contractState" />
                                </td>
                                <td
                                    v-show="showColumn(TableColumn.EMAIL)"
                                    class="kgr-table__cell"
                                >
                                    <a
                                        v-if="attendee.member.email"
                                        :href="'mailto:' + attendee.member.email"
                                        :title="attendee.member.email"
                                    >
                                        <kgr-icon
                                            class="kgr-icon kgr-icon--small"
                                            icon-class="email"
                                        />
                                    </a>
                                </td>
                                <td
                                    v-show="showColumn(TableColumn.PHONE)"
                                    class="kgr-table__cell"
                                >
                                    {{ attendee.member.phone }}
                                </td>
                                <td
                                    v-show="showColumn(TableColumn.PHONE_MOBILE)"
                                    class="kgr-table__cell"
                                >
                                    {{ attendee.member.phoneMobile }}
                                </td>
                                <td
                                    v-show="showColumn(TableColumn.AGE)"
                                    class="kgr-table__cell"
                                >
                                    {{ attendee.member.age }}
                                </td>
                                <td
                                    v-show="showColumn(TableColumn.EMERGENCY_CONTACT)"
                                    class="kgr-table__cell"
                                >
                                    {{ attendee.member.emergencyContact }}
                                </td>
                                <td
                                    v-show="showColumn(TableColumn.CONTRACT_END)"
                                    class="kgr-table__cell"
                                >
                                    {{ formatContractEnd(attendee.member.contractEnd) }}
                                </td>
                                <td
                                    v-show="showColumn(TableColumn.DEPARTMENTS)"
                                    class="kgr-table__cell"
                                >
                                    {{ parseMemberDepartments(attendee.member) }}
                                </td>
                                <td
                                    v-show="showColumn(TableColumn.COMMENT)"
                                    class="kgr-table__cell"
                                >
                                    {{ attendee.comment }}
                                </td>
                                <td class="kgr-table__cell"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <kgr-table-configuration
                    v-if="offering && tableColumns.length > 0"
                    ref="tableConfiguration"
                    :offering="offering"
                    :table-columns="tableColumns"
                    :user-id="userId"
                    :show-dialog="showTableConfiguration"
                    :type="TableColumn.TABLE_TYPE_ATTENDANCE"
                    @change="updateColumns"
                    @closeDialog="closeTableConfigurationDialog()"
                />
            </div>
        </div>
    </kgr-form-scaffold>
</template>
<script>

import AttendeesRepository from '../../js/repository/AttendeesRepository';
import CourseOfferingRepository from '../../js/repository/club/offering/CourseOfferingRepository.js';
import Dropdown from '../../components/common/form/select/Dropdown.vue';
import ExamOfferingRepository from '../../js/repository/club/offering/ExamOfferingRepository.js';
import FormScaffold from '../../components/common/form/FormScaffold.vue';
import GenericOfferingRepository from '../../js/repository/club/offering/GenericOfferingRepository.js';
import Icon from '../../components/common/icon/Icon.vue';
import KgrButton from '../../components/common/form/button/KgrButton.vue';
import KgrMemberContractStateIcon from '../../components/members/MemberContractStateIcon.vue';
import OfferingBookingRepository from '../../js/repository/club/offering/OfferingBookingRepository.js';
import OfferingLiveSearchResultPreview from '../../components/offering/OfferingLiveSearchResultPreview.vue';
import TableColumn from '../../js/dto/offering/TableColumn.js';
import TableColumnRepository from '../../js/repository/club/offering/TableColumnRepository.js';
import TableConfiguration from '../../components/offering/appointment/TableConfiguration.vue';
import TrainingOfferingRepository from '../../js/repository/club/offering/TrainingOfferingRepository.js';
import moment from 'moment';

export default {
    components: {
        'kgr-icon': Icon,
        'kgr-member-contract-state-icon': KgrMemberContractStateIcon,
        'kgr-offering-live-search-result-preview': OfferingLiveSearchResultPreview,
        'kgr-button': KgrButton,
        'kgr-form-scaffold': FormScaffold,
        'kgr-dropdown': Dropdown,
        'kgr-table-configuration': TableConfiguration,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        offeringId: {
            type: String,
            required: true,
        },
        offeringCategory: {
            type: String,
            required: true,
        },
        appointmentSeriesId: {
            type: String,
            required: true,
        },
        start: {
            type: String,
            required: true,
        },
        overviewUrl: {
            type: String,
            required: true,
        },
        userId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pendingAttendanceList: false,
            pendingOffering: false,
            attendanceList: [],
            offering: null,
            showSelectedParticipantModal: false,
            sortOrder: { value: 'desc', label: this.$t('Absteigend') },
            sortBy: { value: 'status', label: this.$t('Status') },
            sortByOptions: [
                { value: 'firstName', label: this.$t('Vorname') },
                { value: 'lastName', label: this.$t('Nachname') },
                { value: 'status', label: this.$t('Status') },
            ],
            sortOrderOptions: [
                { value: 'asc', label: this.$t('Aufsteigend') },
                { value: 'desc', label: this.$t('Absteigend') },
            ],
            loadingAddParticipant: false,
            selectedSalesListOfferingItems: [],
            tableColumns: [],
            selectedColumns: null,
            showTableConfiguration: false,
        };
    },
    computed: {
        TableColumn() {
            return TableColumn;
        },
        pending() {
            return this.pendingAttendanceList || this.pendingOffering;
        },
        isDogExam() {
            return this.offering?.isExamForDogs() ?? false;
        },
        placeholderString() {
            return this.isDogExam ? this.$t('Hund hinzufügen') : this.$t('Teilnehmer hinzufügen');
        },
        sortedList() {
            return [...this.attendanceList].sort((a, b) => {
                let aValue, bValue;

                if (this.sortBy.value === 'firstName' || this.sortBy.value === 'lastName') {
                    aValue = a.member[this.sortBy.value];
                    bValue = b.member[this.sortBy.value];
                } else {
                    aValue = a[this.sortBy.value];
                    bValue = b[this.sortBy.value];
                }

                if (this.sortOrder.value === 'asc') {
                    return aValue > bValue ? 1 : -1;
                }
                return aValue < bValue ? 1 : -1;
            });
        },
        bookedList() {
            return this.sortedList.filter(attendant => attendant.bookingStatus === 'booked');
        },
    },
    watch: {
        tableColumns() {
            this.$nextTick(this.updateColumns);
        },
        offering() {
            this.$nextTick(this.updateColumns);
        },
    },
    created() {
        this.loadAttendanceList();
        this.loadOffering();
        this.loadTableColumns();
    },
    methods: {
        loadAttendanceList() {
            this.pendingAttendanceList = true;
            this.attendanceList = [];
            AttendeesRepository.findAll(this.appointmentSeriesId, this.start)
                .then(data => this.attendanceList = data)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.pendingAttendanceList = false);
        },
        loadOffering() {
            this.pendingOffering = true;
            this.offering = null;
            switch (this.offeringCategory) {
                case 'course':
                    CourseOfferingRepository.find(this.offeringId)
                        .then(data => this.offering = data)
                        .catch(() => this.$notify.error('error.loadingData'))
                        .finally(() => this.pendingOffering = false);
                    break;
                case 'training':
                    TrainingOfferingRepository.find(this.offeringId)
                        .then(data => this.offering = data)
                        .catch(() => this.$notify.error('error.loadingData'))
                        .finally(() => this.pendingOffering = false);
                    break;
                case 'exam':
                    ExamOfferingRepository.find(this.offeringId)
                        .then(data => this.offering = data)
                        .catch(() => this.$notify.error('error.loadingData'))
                        .finally(() => this.pendingOffering = false);
                    break;
                default:
                    GenericOfferingRepository.find(this.offeringId)
                        .then(data => this.offering = data)
                        .catch(() => this.$notify.error('error.loadingData'))
                        .finally(() => this.pendingOffering = false);
            }
        },
        loadTableColumns() {
            const allowedKeys = [
                TableColumn.CONTRACT_STATUS,
                TableColumn.EMAIL,
                TableColumn.PHONE,
                TableColumn.PHONE_MOBILE,
                TableColumn.AGE,
                TableColumn.EMERGENCY_CONTACT,
                TableColumn.CONTRACT_END,
                TableColumn.DEPARTMENTS,
                TableColumn.COMMENT,
            ];
            TableColumnRepository.findByClub(this.clubId, this.offeringId)
                .then(data => this.tableColumns = data.filter(col => allowedKeys.includes(col.key)))
                .catch(() => this.$notify.error('error.loadingData'));
        },
        showColumn(column) {
            if (!this.selectedColumns) {
                return true;
            }
            return this.selectedColumns.includes(column);
        },
        updateColumns() {
            if (!this.$refs.tableConfiguration) {
                return;
            }
            this.selectedColumns = this.$refs.tableConfiguration.loadConfiguration();
        },
        openTableConfigurationDialog() {
            this.showTableConfiguration = true;
        },
        closeTableConfigurationDialog() {
            this.showTableConfiguration = false;
        },
        formatContractEnd(contractEnd) {
            return contractEnd ? moment(contractEnd, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
        },
        parseMemberDepartments(member) {
            return member.departments ? member.departments.join(', ') : '';
        },
        saveParticipant(data) {
            this.loadingAddParticipant = true;
            const appointment = {
                appointmentSeries: {
                    id: this.appointmentSeriesId
                },
                start: {
                    date: this.start,
                },
            };
            OfferingBookingRepository.addParticipant(this.clubId, data.id, appointment, data.selectedExams, this.selectedSalesListOfferingItems)
                .then(() => {
                    this.$notify.success('Der Teilnehmer wurde hinzugefügt');
                    this.loadAttendanceList();
                })
                .catch((error) => this.$notify.error(error.message))
                .finally(() => this.loadingAddParticipant = false);
        },
        saveDogAndParticipant(params) {
            this.loadingAddParticipant = true;
            const appointment = {
                appointmentSeries: {
                    id: this.appointmentSeriesId
                },
                start: {
                    date: this.start,
                },
            };
            OfferingBookingRepository.addDogAndParticipant(this.clubId, params, appointment, this.selectedSalesListOfferingItems)
                .then(() => {
                    this.$notify.success('Der Teilnehmer wurde hinzugefügt');
                    this.loadAttendanceList();
                    this.$emit('updateBookings', appointment);
                })
                .catch((error) => this.$notify.error(error.message))
                .finally(() => this.loadingAddParticipant = false);
        },
        changeStatus(attendee, status) {
            attendee.status = status;
            this.pendingAttendanceList = true;

            if (attendee.id) {
                AttendeesRepository.updateAttendee(attendee)
                    .then(() => this.$notify.success('saveChanges.success'))
                    .catch(() => this.$notify.error('error.loadingData'))
                    .finally(() => this.pendingAttendanceList = false);
            } else {
                AttendeesRepository.createAttendee(attendee)
                    .then((id) => {
                        attendee.id = id;
                        this.$notify.success('saveChanges.success');
                    })
                    .catch(() => this.$notify.error('error.loadingData'))
                    .finally(() => this.pendingAttendanceList = false);
            }
        },
        back() {
            window.location = this.overviewUrl;
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.openConfig {
    cursor: pointer;
}
.openConfigColumn {
    width: 1px;
    white-space: nowrap;
}
.xScrollable {
    overflow-x: auto;
    scrollbar-gutter: stable;
}
</style>
